<form *ngFor="let signature of signaturesArray, let i = index" class="signature-question-container">
  <div *ngIf="!question.isPredefinedSignature" style="display: flex; width: 100%;">
    <div id="yourDivId" style="width: 90%;">
      <ion-searchbar id="searchUserBar" class="userSearchBar" [placeholder]="customPlaceholder"
        search-icon="search-circle" name="searchUserBar" [(ngModel)]="signaturesArray[signature.id].textContent"
        (ionInput)="filterUsers(signature.id, signaturesArray[signature.id].textContent, initialUsersList)"
        (click)="openPopover(signature.id)" (ionClear)="clearUserId(signature.id,signature)" [searchText]="searchText"
        [filteredUsers]="filteredUsers">
      </ion-searchbar>
      <app-search-results-popover
        *ngIf="selectedSignatureId === signature.id && (question.isUserSelectAndTextFree || question.isUserSelectOnly || question.isPredefinedSignature ) && filteredUsers.length > 0"
        class="search-results-container" [users]="filteredUsers"
        [isCustomPopoverOpen]="isCustomPopoverOpen && signature.isDropDown" (userSelected)="selectUser($event, i)">
      </app-search-results-popover>



    </div>
    <div class=" search-buttons-container">
      <ion-button *ngIf="!question.isUserSelectOnly" [disabled]="signature.disableAdd" class="search-button-style"
        fill="outline" (click)="addUser(signature)">
        Add
      </ion-button>
      <ion-button *ngIf="question.isUserSelectOnly" [disabled]="signature.disableAdd || !isUserInReserveList(i)"
        class="search-button-style" fill="outline" (click)="addUser(signature)">
        Add
      </ion-button>
      <!-- <ion-button class="search-button-style" fill="outline" color="danger" (click)="removeSignature(signature.id)">Delete</ion-button> -->
    </div>
    <button *ngIf="signature.id === signaturesArray.length - 1 && signature.id !== 0" ion-button clear
      class="trash-button-container close-button-container" (click)="removeSignature(signature, i)">
      <ion-icon class="close-button-content" name="close"></ion-icon>
    </button>
  </div>
  <div *ngIf="question.isPredefinedSignature && !isSavedState"
    style="width: 100% !important; display: flex; justify-content: space-between; align-items: center;">
    <p style="margin-left: 15px;">{{ selectedPreUserName }}</p>
    <ion-button *ngIf="isDone" [disabled]="isAddButtonDisabled(signature.id)" class="search-button-style" fill="outline"
      (click)="addUser(signature)" style="width:70px !important;">
      Add
    </ion-button>
    <button *ngIf="!isDone" ion-button clear class="trash-button-container"
      (click)="removeUser(signature.id, signature)" style="margin-right: 15px;">
      <ion-icon name="trash"></ion-icon>
    </button>
  </div>
  <div *ngIf="question.isPredefinedSignature && isSavedState"
    style="width: 100% !important; display: flex; justify-content: space-between; align-items: center;">
    <p style="margin-left: 15px;">{{ selectedPreUserName }}</p>
    <ion-button *ngIf="isDone" [disabled]="isAddButtonDisabled(signature.id)" class="search-button-style" fill="outline"
      (click)="addUser(signature)" style="width:70px !important;">
      Add
    </ion-button>
    <button *ngIf="!isDone" ion-button clear class="trash-button-container"
      (click)="removeUserForSavedStat(signature.id, signature)" style="margin-right: 15px;">
      <ion-icon name="trash"></ion-icon>
    </button>
  </div>

  <div *ngIf="isSavedState && signature.questionSigImage !== '' && !signature.isPopoverOpen"
    style="display: flex; flex-direction: column; width: 100%; align-items: center;" [id]="signature.id">
    <div *ngIf="!question.isPredefinedSignature" class="selected-result-container">
      {{ signature.textContent }}
      <button ion-button clear class="trash-button-container" (click)="removeUserForSavedStat(signature.id, signature)">
        <ion-icon name="trash"></ion-icon>
      </button>
    </div>
    <div
      style="width: 365px; height: 175.2px; position: relative; user-select: none; background: #E8EAF2; border: 1px solid #CACEE1; border-radius: 4px;">
      <div
        style="position: absolute; width: 365px; height: 175.2px; left: 0px; top: 0px; touch-action: none; user-select: none;">
        <img [src]="signature.questionSigImage" alt="" style="width: 100%; height: 100%;">
      </div>
    </div>
  </div>

  <div style="display: flex; flex-direction: column; width: 100%;" [id]="signature.id"
    *ngIf="shouldDisplaySelectedUser(signature.id) && signature.isPopoverOpen || question.isPredefinedSignature && tester">
    <div *ngIf="!question.isPredefinedSignature" class="selected-result-container">
      {{ getSelectedUserById(signature.id)?.textContent }}
      <button ion-button clear class="trash-button-container" (click)="removeUser(signature.id, signature)">
        <ion-icon name="trash"></ion-icon>
      </button>
    </div>
    <ion-item class="signature-area-container">
      <app-signature-area class="signature-area-component"
        [currentElementId]="question.questionId.toString() + signature.id.toString()"
        (outputToParent)="GetOutPutVal($event)"
        (outputToQuestionParent)="GetOutPutQuestionVal($event, i)"></app-signature-area>
    </ion-item>

  </div>
</form>
<div *ngIf="question.isDynamicAddSignature">
  <ion-item class="add-signature-area-button">
    <ion-button fill="clear" class="add-signature-button" (click)="addSignatureArea()">Add new inform
      signature</ion-button>
  </ion-item>
</div>
<div style="height: 20px; width: 100%;"></div>